import { useAuth0 } from '@auth0/auth0-react';
import Button from '@mui/material/Button';
import * as Sentry from '@sentry/react';
import { useCallback } from 'react';
import { useAppDispatch } from '../../app/hooks';
import { persistor } from '../../app/store';
import { setApiToken } from '../auth/authSlice';

const LogoutButton: React.FC = () => {
  const dispatch = useAppDispatch();
  const { logout } = useAuth0();

  const handleClick = useCallback(() => {
    dispatch(setApiToken(null));
    Sentry.setUser(null);
    logout({ returnTo: `${window.location.origin}/login` });
    persistor.purge();
  }, [dispatch, logout]);

  return (
    <>
      <Button
        variant='contained'
        sx={{
          width: '100%',
          maxWidth: '20rem',
          whiteSpace: 'nowrap',
        }}
        onClick={handleClick}
      >
        Log Out
      </Button>
    </>
  );
};

export default LogoutButton;
